import React from 'react';
import { Tooltip } from 'antd';
import useTranslation from '../../hooks/translation/useTranslation';

function WagonToilet({ className = 'wagon-feature', title = 'toilet', style = {} }) {
  const { trans } = useTranslation();
  return (
    <div className={`${className}`} style={style}>
      <Tooltip title={trans(title)}>
        <img src="/wagon-icons/toilet.png" width={46} height={46} className="object-center" alt="toilet" />
      </Tooltip>
    </div>
  );
}

export default WagonToilet;
